export default {
  chipTitle: {
    id: 'product_jp_backup_chip_title',
    defaultMessage: 'Protect your device with BackUp',
  },
}
